import { GoogleAuthClient } from "./providers/google/mod";
import { OutlookAuthClient } from "./providers/outlook/mod";
import { AuthProvider } from "./types";

type AuthClientOptions = {
	provider: AuthProvider;
	appUrl: string;
	fallbackRedirectUrl?: string;
};

export function createAuthClient(
	opts: AuthClientOptions,
): GoogleAuthClient | OutlookAuthClient {
	if (opts.provider.name === "google") {
		return new GoogleAuthClient({
			appUrl: opts.appUrl,
			flowType: opts.provider.flowType,
			fallbackRedirectUrl: opts.fallbackRedirectUrl,
			oneTap: opts.provider.oneTap,
		});
	}

	throw new Error("Unsupported provider");
}
